import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Scroll from 'react-scroll';
import ConfigContext from '../../../contexts/ConfigContext';
import { photoUrl } from '../../vendor/truck/profile/profileSummary';
import { BrandInstagramIcon, PlayFilledIcon, StackIcon } from '../../shared/InstagramIcons';
import styles from './TruckInstagram.module.postcss';

// The public page's From Instagram section (design/instagram-feed-options-v1),
// under About. The server decides what shows (instagram_feed: 8 posts at 8+
// visible, one row of 4 at 4-7, nothing otherwise), so this only draws it.
// Posts are our own copies of the images and open on Instagram in a new tab;
// videos show their cover with a play mark and don't play here, and a
// multi-photo post shows its first photo with a stack mark. The frame is
// drawn on the Seattle design system; this uses each city's own section
// heading and outlined button, as the dev notes ask.
export default function TruckInstagram({ feed }) {
  const { imageBase } = useContext(ConfigContext);
  if (!feed || !feed.posts || feed.posts.length < 4) return null;

  const profileUrl = `https://www.instagram.com/${feed.username}/`;

  return (
    <Scroll.Element name='instagram' className='InnerSection'>
      <div className={styles.Head}>
        <h2 className={styles.Title}>From Instagram</h2>
        <a className={styles.Handle} href={profileUrl} target='_blank' rel='noopener noreferrer'>
          <BrandInstagramIcon className={styles.HandleIcon} />
          @{feed.username}
        </a>
      </div>

      <ul className={styles.Grid}>
        {feed.posts.map((post) => (
          <li key={post.id} className={styles.Post}>
            <a
              className={styles.PostLink}
              href={post.permalink || profileUrl}
              target='_blank'
              rel='noopener noreferrer'
              aria-label={post.caption ? `View on Instagram: ${post.caption.slice(0, 80)}` : 'View on Instagram'}
            >
              <img
                className={styles.PostImg}
                src={photoUrl(imageBase, post.image)}
                alt=''
                loading='lazy'
                decoding='async'
              />
              { post.media_type === 'VIDEO' && <PlayFilledIcon className={styles.Mark} /> }
              { post.media_type === 'CAROUSEL_ALBUM' && <StackIcon className={styles.Mark} /> }
              <span className={styles.Hover} aria-hidden='true'>
                { post.caption && <span className={styles.Caption}>{post.caption}</span> }
                <span className={styles.View}>
                  <BrandInstagramIcon className={styles.ViewIcon} />
                  View on Instagram
                </span>
              </span>
            </a>
          </li>
        ))}
      </ul>

      <a className={`Button Button--outlined ${styles.Follow}`} href={profileUrl} target='_blank' rel='noopener noreferrer'>
        Follow on Instagram
      </a>
    </Scroll.Element>
  );
}

TruckInstagram.propTypes = {
  feed: PropTypes.shape({
    username: PropTypes.string,
    posts: PropTypes.arrayOf(PropTypes.object),
  }),
};
